import { Suggestion } from './../modules/shared/models/suggestion';
import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreCollection,
  AngularFirestoreDocument
} from 'angularfire2/firestore';
import * as firebase from 'firebase';
import { Observable } from 'rxjs/Observable';
import { Investor } from '../modules/shared/models/investor';
import { AuthService } from '../core/auth.service';
import { User } from '../core/user';

@Injectable()
export class SuggestionDataService {

  user: User;
  investor: Investor;
  private suggestionCollection: AngularFirestoreCollection<Suggestion>;

  constructor(private afs: AngularFirestore, private authService: AuthService) {
    this.suggestionCollection = this.afs.collection<Suggestion>('SuggestionData');
    authService.getCurrentUser().subscribe(user => {
      this.user = user;
    })
  }

  getLatestSuggestionData(iid: string): AngularFirestoreCollection<Suggestion> {
    return this.afs.collection<Suggestion>('SuggestionData', ref => {
      return ref.orderBy('updatedAt', 'desc').limit(1).where('iid', '==', iid);
    })
  }
  
  saveAssetSuggestions(assetData, sipData, iid, adjustmentAmount,callback, errorCallback) {
    var data = {
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      RAName: this.user.displayName,
      iid: iid,
      data: JSON.stringify(assetData),
      sipData: JSON.stringify(sipData),
      adjustmentAmount: adjustmentAmount,
    };
    this.afs.collection('AssetSuggestion').doc(iid).set(data).then(callback).catch(errorCallback);
  }

  getAssetSuggestions(iid): Observable<Object> {
    return this.afs.collection('AssetSuggestion').doc(iid).valueChanges();
  }

  addSuggestionData(data: Suggestion, investor: Investor) {
    console.log("SAVING", "add suggestion", data)
    // data.searchName = data.name.toLocaleLowerCase();
    // const cleanData = JSON.parse(JSON.stringify(data));
    data.createdAt = firebase.firestore.FieldValue.serverTimestamp();
    data.updatedAt = firebase.firestore.FieldValue.serverTimestamp();
    data.RAName = this.user.displayName;
    data.iid = investor.iid;

    console.log(data);
    if (!this.user.displayName) {
      console.log("display name not found");
      return;
    }
    console.log(this.user.displayName);
    this.suggestionCollection
      .add(data)
      .then(value => {
        console.log(value);
        console.log(value.id);
        data.sid = value.id;
        this.afs.doc<Object>(`SuggestionData/${value.id}`).set(
          {
            sid: value.id
          },
          {
            merge: true
          }
        );
      })
      .catch(error => {
        console.log(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/suggestion-data.service.ts